import { regex } from "./regex-patterns";

export const Messages = {
  AUTH: {
    EMAIL_REQUIRED: 'Email is required.',
    INVALID_EMAIL: 'Please enter a valid email address.',
    INVALID_PHONE: 'Please enter a valid 10-digit phone number.',
    PASSWORD_REQUIRED: 'Password is required.',
    PASSWORD_PATTERN: 'Password must contain one numeric, one special character, one uppercase and one lowercase.',
    LOGIN_SUCCESS: "Login Successful.",
    FETCH_USER_FAILED: "Failed to fetch user details. Please try again.",
    LOGOUT_SUCCESS: "Logged out successfully.",
    LOGOUT_ALL_SUCCESS: "Logged out from all devices successfully.",
    ACCOUNT_IDLE_LOGOUT: "You have been logged out due to inactivity.",
    OLD_PASSWORD_REQUIRED: "Please enter your old password.",
    INVALID_OLD_PASSWORD: "Old password is incorrect.",
    PASSWORD_CHANGED: "Password changed successfully.",
    PASSWORD_CHANGE_FAILED: "Unable to change password. Please try again.",
    NEW_PASSWORD_REQUIRED: "Please enter your new password.",
    CONFIRM_PASSWORD_REQUIRED: "Please confirm your new password.",
    PASSWORD_CHANGED_LOGOUT: "Your password has been changed successfully. For security reasons, you have been logged out. Please log in again with your new password.",
    PASSWORD_MIN_LENGTH: `Password must be at least ${regex.PASSWORD_RULES.MIN_LENGTH_PASSWORD} characters long.`,
    PASSWORD_MISMATCH: "New password and confirm password do not match.",
    RESET_LINK_SENT: "Password reset link has been sent to your email.",
    RESET_LINK_SENT_FAILED: "Failed to send reset link. Please try again.",
    RESET_LINK_INVALID: "The password reset link is invalid or has expired.",
    PASSWORD_RESET_SUCCESS: "Your password has been reset successfully. Please log in with your new password.",
    PASSWORD_RESET_FAILED: "Failed to reset password. Please try again.",

    PASSWORD_SET_SUCCESS: "Your password has been set successfully. Please log in with your new password.",
    PASSWORD_SET_FAILED: "Failed to set password. Please try again.",
  },
  PASSWORD_RULES: {
    SAME_AS_OLD: 'New password must be different from old password',
    PASSWORD_MIN_LENGTH: `Minimum ${regex.PASSWORD_RULES.MIN_LENGTH_PASSWORD} characters`,
    UPPERCASE_PASSWORD: "At least 1 uppercase letter",
    LOWERCASE_PASSWORD: "At least 1 lowercase letter",
    NUMBER_PASSWORD: "At least 1 number",
    SPECIAL_PASSWORD: "At least 1 special character",
    PASSWORD_INVALID: "Incorrect password.",

  },
  PROFILE: {
    FETCH_FAILED: 'Unable to load profile',
    FETCH_SUCCESS: 'Profile fetched successfully',
  }
};